import { FC } from "react";
import { Platform } from "react-native";

import { VnBox } from "@/components/VnBox";
import { BaseCheckboxInput } from "@/components/VnCheckboxInput/BaseCheckboxInput";
import { VnText } from "@/components/VnText/VnText";
import { VnTouchableOpacity } from "@/components/VnTouchableOpacity";
import { ChildrenOrI18nType } from "@/i18n";
import { cn } from "@/utils/tailwind";

type WorkRequirementSelectableRowPropsType = ChildrenOrI18nType & {
  isChecked: boolean;
  onToggle: () => void;
  className?: string;
};

export const WorkRequirementSelectableRow: FC<
  WorkRequirementSelectableRowPropsType
> = ({ isChecked, onToggle, className, ...labelProps }) => (
  <VnBox
    className={cn(
      "bg-card border-border shadow-base rounded-md border",
      className,
    )}>
    <VnTouchableOpacity
      accessibilityRole="checkbox"
      accessibilityState={{ checked: isChecked }}
      shouldDebounce={false}
      onPress={onToggle}
      className={cn(
        "flex-row items-center gap-3 p-4",
        Platform.select({ web: "cursor-pointer" }),
      )}>
      <BaseCheckboxInput
        checked={isChecked}
        onCheckedChange={onToggle}
        className="web:pointer-events-none"
      />
      <VnText variant="md" className="flex-1" {...labelProps} />
    </VnTouchableOpacity>
  </VnBox>
);
